import { useAccountAging } from '../hooks/usePlaneteCourrier';

interface AgingSummaryProps {
  accountNumber: string;
}

export function AgingSummary({ accountNumber }: AgingSummaryProps) {
  const { data: aging, isLoading } = useAccountAging(accountNumber);

  if (isLoading || !aging) return null;

  const intervals = aging.agingIntervals.filter((i) => i.label !== 'Total');
  const total = aging.agingIntervals.find((i) => i.label === 'Total');

  return (
    <div className="flex gap-3 items-center">
      <span className="text-sm font-medium">Aging:</span>
      {intervals.map((interval) => (
        <div key={interval.label} className="text-center">
          <p className="text-xs text-muted-foreground">{interval.label}</p>
          <p className={`text-sm font-mono ${interval.value > 0 ? 'text-red-600 font-semibold' : 'text-muted-foreground'}`}>
            ${interval.value.toFixed(2)}
          </p>
        </div>
      ))}
      {total && (
        <div className="text-center border-l pl-3">
          <p className="text-xs text-muted-foreground">Total Due</p>
          <p className={`text-sm font-mono font-semibold ${total.value > 0 ? 'text-red-600' : 'text-green-600'}`}>
            ${total.value.toFixed(2)}
          </p>
        </div>
      )}
    </div>
  );
}
